import { useState, useEffect } from "react";
import axios from "axios";
import { apiFetch } from "../../api/Api";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Autocomplete, TextField } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import "assets/theme/admin_form.css";

function AddVillage() {
  const navigate = useNavigate();
  const [wards, setWards] = useState([]);
  const [wardId, setWardId] = useState("");
  const [villageName, setVillageName] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);
  useEffect(() => {
    fetchWards();
  }, []);

  const fetchWards = async () => {
    try {
      const res = await apiFetch("super_admin/list_ward");
      setWards(res.wards);
      console.log("ward data",res.wards);
    } catch (err) {
      console.error(err);
    }
  };

 const handleSubmit = async (e) => {
  e.preventDefault();

  if (!wardId || !villageName.trim()) {
    setError("All fields are required");
    setMessage(null);
    return;
  }

  try {
    setLoading(true);
    setError(null);
    setMessage(null);

    const res = await apiFetch("super_admin/add_village", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ward_id: wardId,
        village_name: villageName.trim(),
      }),
    });

    if (res.success) {
      alert(res.message || "Village added successfully");
      navigate("/village_list");
    } else {
      setError(res.message || "Failed to add village");
    }

  } catch (err) {
    setError(err.message || "Server error");
  } finally {
    setLoading(false);
  }
};
 return (
  <DashboardLayout>
    <DashboardNavbar />

    <div className="container-fluid mt-4" style={{ fontSize: "0.9rem" }}>

      {/* Header Card */}
      <div className="admin-form-header-card">
        <div className="d-flex align-items-center gap-3">
          <button type="button" onClick={() => navigate(-1)} className="btn-admin-back">
            <FaArrowLeft />
            <span>मागे जा (Back)</span>
          </button>
          <div>
            <h4 className="fw-bold mb-1 text-white">
              🏘 नवीन परिसर/गाव जोडा (Add Ward Area / Village)
            </h4>
            <small className="text-white-50">Manage ward-wise village / area details</small>
          </div>
        </div>

        <Link to="/village_list" className="btn btn-light btn-sm fw-semibold rounded-pill px-3">
          Area List
        </Link>
      </div>

      {/* Main Card */}
      <div className="card shadow-lg rounded-4 border-0">
        <div className="card-body p-4">

          {message && (
            <div className="alert alert-success">
              {message}
            </div>
          )}

          {error && (
            <div className="alert alert-danger">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="row g-4">

              {/* Ward Search */}
              <div className="col-md-6">
                <Autocomplete
                  options={wards}
                  getOptionLabel={(option) =>
                    `Ward ${option.ward_number} - ${option.ward_name || ""}`
                  }
                  value={
                    wards.find(
                      (w) => w.ward_id === wardId
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    setWardId(
                      newValue ? newValue.ward_id : ""
                    );
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Search Ward"
                      fullWidth
                      required
                    />
                  )}
                />
              </div>

              {/* Village Name */}
              <div className="col-md-6">
                <TextField
                  label="Ward Area Name"
                  fullWidth
                  required
                  value={villageName}
                  onChange={(e) =>
                    setVillageName(e.target.value)
                  }
                />
              </div>

            </div>

            {/* Submit */}
            <div className="text-end mt-4">
              <button
                type="submit"
                className="btn btn-primary px-5 fw-semibold"
                disabled={loading}
                style={{ fontSize: "0.85rem" }}
              >
                {loading ? "Adding..." : "Add Ward Area"}
              </button>
            </div>

          </form>
        </div>
      </div>

    </div>
  </DashboardLayout>
);
}

export default AddVillage;